import { render, staticRenderFns } from "./ShapeBox.vue?vue&type=template&id=08e85435&scoped=true"
import script from "./ShapeBox.vue?vue&type=script&lang=js"
export * from "./ShapeBox.vue?vue&type=script&lang=js"
import style0 from "./ShapeBox.vue?vue&type=style&index=0&id=08e85435&prod&lang=less&scoped=true"
import style1 from "./ShapeBox.vue?vue&type=style&index=1&id=08e85435&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e85435",
  null
  
)

export default component.exports